import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchAdsAndSmbsProps = {
  startDate: Moment;
  endDate: Moment;
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
};
export type FetchAdsAndSmbs = (filters: FetchAdsAndSmbsProps) => void;

const fetchAdsAndSmbs = ({
  startDate,
  endDate,
  clusters = [],
  partners = [],
  origami,
}: FetchAdsAndSmbsProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
  };
  await fetchReport("ads_and_smbs", dispatch, params);
};

export default fetchAdsAndSmbs;
